/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import React, {useEffect, useState} from "react";

import Register from "./Register";

const RegisterContainer = () => {
  const [step, updateStep] = useState(1);
  const [userData, setUserData] = useState({});

  useEffect(() => {
    const stripBareHash = () => {
      if (!window.location.hash && window.location.href.endsWith("#")) {
        const currentScroll = window.scrollY;
        window.history.replaceState(
          null,
          "",
          `${window.location.pathname}${window.location.search}`
        );
        window.scrollTo(0, currentScroll);
      }
    };

    const onHashChanged = (event) => {
      if (event.newURL.includes("#register")) {
        document.body.classList.add("hide-scroll");
      } else {
        document.body.classList.remove("hide-scroll");
        // Close button uses href="#", which leaves a trailing "#". Strip it
        // after :target has already dismissed the modal.
        stripBareHash();
      }
    };

    window.addEventListener("hashchange", onHashChanged);

    return () => {
      window.removeEventListener("hashchange", onHashChanged);
    };
  }, []);

  useEffect(() => {
    if (userData.email && userData.email.length) {
      window.dataLayer?.push({
        ...userData
      });
    }
  }, [userData]);

  return (
    <Register
      setUserData={setUserData}
      step={step}
      updateStep={updateStep}
      userData={userData}
    />
  );
};

export default RegisterContainer;
